import React, { useEffect, useState } from 'react';
import { Divider, Form, Button, Tabs, message, Row, Col, Card } from 'antd';

import { formatObjectAsDotpath } from "../../../utils/tools";
import {
    portfolioNameInput,
    portfolioDescription,
    portfolioUseCase,
    benchmarkInput,
    targetAllocationSlider,
    objectiveSelect
} from "./components/FormFields";
import PortfolioSearch from "../../../modules/Search/PortfolioSearch/PortfolioSearch";
import TickerSearch from "../../../modules/Search/TickerSearch/TickerSearch";

const PresentForm = ({
    selectedTickers, handleTickerUpdate, selectedPortfolios,
    handlePortfolioUpdate
}) => {
    return (
        <Tabs centered={true}>
            <Tabs.TabPane key={'1'} tab={'Comparison Tickers'}>
                <TickerSearch
                    initialSymbols={selectedTickers}
                    onTickersSubmit={handleTickerUpdate}
                    maxTickers={10}
                />
            </Tabs.TabPane>
            <Tabs.TabPane key={'2'} tab={'Comparison Portfolios'}>
                <PortfolioSearch
                    initialSelectedPortfolios={selectedPortfolios}
                    onSelect={handlePortfolioUpdate}
                />
            </Tabs.TabPane>
        </Tabs>
    );
}

const PortfolioForm = ({ portfolioId, initialValues, handleSubmit }) => {
  const [form] = Form.useForm();
  const [equityAllocation, setEquityAllocation] = useState(initialValues?.targets?.equity);
  const [selectedTickers, setSelectedTickers] = useState(initialValues?.view_config?.comparison?.ticker_ids || []);
  const [selectedPortfolios, setSelectedPortfolios] = useState(initialValues?.view_config?.comparison?.portfolio_ids || []);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      setEquityAllocation(initialValues?.targets?.equity);
    }
  }, [initialValues, form]);

  const onSliderChange = (value) => setEquityAllocation(value);
  const handleTickerUpdate = (tickers) => {
    const formattedList = tickers.map(ticker => ticker.symbol);
    setSelectedTickers(formattedList);
    form.setFieldsValue({ 'view_config.comparison.ticker_ids': formattedList });
  };
  const handlePortfolioUpdate = (portfolios) => {
    const portfolioIds = portfolios.map(portfolio => portfolio.id);
    setSelectedPortfolios(portfolioIds);
    form.setFieldsValue({ 'view_config.comparison.portfolio_ids': portfolioIds });
  };

  const onSubmit = (values) => {
    const updatedValues = {
      ...values,
      'targets.equity': equityAllocation,
      'targets.fixed': 100 - equityAllocation,
      'view_config.comparison.ticker_ids': selectedTickers,
      'view_config.comparison.portfolio_ids': selectedPortfolios,
    };
    const data = formatObjectAsDotpath(updatedValues, '', {}, true);
    const payload = { portfolioId, data };
    handleSubmit(payload);
    message.success(`Portfolio ${data.name} updated successfully!`);
  };

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Row justify={'center'} style={{borderBottom: '1px solid #ededed'}}>
            <Button htmlType={'submit'} type={'primary'}>
              Save & Finish
            </Button>
        </Row>
      <Tabs centered={true} tabPosition={'left'}>
        <Tabs.TabPane key={'1'} tab={'Details'}>
            <Card bordered={false} className={'py-12 px-16'}>
                <Row gutter={[24, 24]}>
                    {/* Left column for all the form items except useCases and description */}
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {portfolioNameInput()}
                      </div>
                      <Divider />
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {benchmarkInput()}
                      </div>
                      <Divider />
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {targetAllocationSlider({ equityAllocation, onSliderChange })}
                      </div>
                      <Divider />
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {objectiveSelect()}
                      </div>
                    </Col>
                    {/* Right column for useCases and description */}
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {portfolioDescription()}
                      </div>
                      <Divider />
                      <div style={{ marginBottom: '24px', padding: '20px 30px' }}>
                        {portfolioUseCase()}
                      </div>
                    </Col>
                </Row>
            </Card>
        </Tabs.TabPane>
        <Tabs.TabPane key={'2'} tab={'Present'}>
            <Row justify={'center'} style={{marginTop: '24px'}}>
                <Card bordered={false} style={{maxWidth: 1000}}>
                    <PresentForm
                        selectedTickers={selectedTickers}
                        handleTickerUpdate={handleTickerUpdate}
                        selectedPortfolios={selectedPortfolios}
                        handlePortfolioUpdate={handlePortfolioUpdate}
                      />
                </Card>
            </Row>
        </Tabs.TabPane>
      </Tabs>
    </Form>
  );
};

export default PortfolioForm;
